import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadActuality, IActualityData } from 'redux/reducers/actuality';
import { RootState } from 'redux/rootReducer';
import { FeedTypes } from 'url-constructors/getActualityURL';
import useCustomerFilters from './useCustomerFilters';
import { useLocation } from 'react-router';

const useDateRangeKPI = (
  KPIType: FeedTypes
): (IActualityData | undefined)[] => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [, customerFilter, isFilterLoaded] = useCustomerFilters(KPIType);

  useEffect(() => {
    if (isFilterLoaded) {
      // dispatch(loadActuality(KPIType, customerFilter));
      // TODO: find a bug with routing that lost location search
      const realLocation = window?.location?.search;
      const hasCustomFilter =
        (KPIType === 'downloads' && realLocation?.indexOf('download') > -1) ||
        (KPIType === 'streaming' && realLocation?.indexOf('streaming') > -1);
      const dspApplied = hasCustomFilter
        ? realLocation === location?.search
        : true;
      if (dspApplied) {
        dispatch(loadActuality(KPIType, customerFilter));
      }
    }
    // }, [dispatch, KPIType, isFilterLoaded, customerFilter]);
  }, [dispatch, KPIType, customerFilter, isFilterLoaded, location]);

  const actualityData = useSelector((state: RootState) => {
    return state.actuality.data;
  });

  const thisWeekToDate = useMemo(() => {
    if (actualityData) {
      return actualityData.find((data: IActualityData) => data.name === 'TWTD');
    }
  }, [actualityData]);

  const lastWeek = useMemo(() => {
    if (actualityData) {
      return actualityData.find((data: IActualityData) => data.name === 'LW');
    }
  }, [actualityData]);

  return [thisWeekToDate, lastWeek];
};

export default useDateRangeKPI;
